enum ETipoDeDado {
  Indefinido = 'Indefinido',
  String = 'String',
  Integer = 'Integer',
  Number = 'Number',
  Boolean = 'Boolean',
  Date = 'Date',
  DateTime = 'DateTime',
  Personalizado = 'Personalizado',
}

export default ETipoDeDado;

export const cNOME_AMIGAVEL_TIPO_DE_DADO: Record<ETipoDeDado, string> = {
  [ETipoDeDado.Indefinido]: 'Indefinido',
  [ETipoDeDado.String]: 'Texto',
  [ETipoDeDado.Integer]: 'Números Inteiros',
  [ETipoDeDado.Number]: 'Números',
  [ETipoDeDado.Boolean]: 'Lógico',
  [ETipoDeDado.Date]: 'Data',
  [ETipoDeDado.DateTime]: 'Data e Hora',
  [ETipoDeDado.Personalizado]: 'Personalizado',
};
